var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"archival-table"},[_vm._m(0),_c('tbody',[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Workflow ID")]),_c('th',[_vm._v("Run ID")]),_c('th',[_vm._v("Name")]),_c('th',[_vm._v("Status")]),_c('th',[_vm._v("Start time")]),_c('th',[_vm._v("End time")])])
}]

export { render, staticRenderFns }